import { ConversationMessageInput } from '@modules/conversation-message/ConversationMessageInput';
import type { Editor } from '@tiptap/react';
import { ChatInput } from '../shared/ChatMessageInput/styles';
import { useChatConversationContext } from './useChatConversationContext';

type Props = {
  editor: Editor;
  onFileSelect: (type: string, file: File) => void;
};

export const ChatConversationMessageInput = ({
  editor,
  onFileSelect,
}: Props) => {
  const {
    handleTextMessage: handleTextMessageContext,
    onSendSoundBoard,
    userPermissions,
    showInput,
  } = useChatConversationContext();

  const handleTextMessage = (message: string) => {
    handleTextMessageContext(message);
    editor.commands.setContent('');
  };

  return (
    showInput && (
      <ChatInput>
        <ConversationMessageInput
          handleTextMessage={handleTextMessage}
          handleFileSelect={onFileSelect}
          onSendSoundBoard={onSendSoundBoard}
          editor={editor}
          disabled={!userPermissions.sendMessage}
          showMediaInputActions
        />
      </ChatInput>
    )
  );
};
